/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewIPDetails
 */
export interface CRSFSecReviewIPDetails {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewIPDetails
     */
    issuer: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewIPDetails
     */
    not_after: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewIPDetails
     */
    not_before: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewIPDetails
     */
    sans: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewIPDetails
     */
    subject: string;
}

/**
 * Check if a given object implements the CRSFSecReviewIPDetails interface.
 */
export function instanceOfCRSFSecReviewIPDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "issuer" in value;
    isInstance = isInstance && "not_after" in value;
    isInstance = isInstance && "not_before" in value;
    isInstance = isInstance && "sans" in value;
    isInstance = isInstance && "subject" in value;

    return isInstance;
}

export function CRSFSecReviewIPDetailsFromJSON(json: any): CRSFSecReviewIPDetails {
    return CRSFSecReviewIPDetailsFromJSONTyped(json, false);
}

export function CRSFSecReviewIPDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewIPDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'issuer': json['issuer'],
        'not_after': json['not_after'],
        'not_before': json['not_before'],
        'sans': json['sans'],
        'subject': json['subject'],
    };
}

export function CRSFSecReviewIPDetailsToJSON(value?: CRSFSecReviewIPDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'issuer': value.issuer,
        'not_after': value.not_after,
        'not_before': value.not_before,
        'sans': value.sans,
        'subject': value.subject,
    };
}

